import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export default function ConfirmationAlert(props) {
  const { show, message, onConfirm, onCancel, extraNote } = props;
  return (
    <SweetAlert
      title={message}
      warning
      show={show}
      showCancel
      reverseButtons
      cancelBtnBsStyle="danger"
      confirmBtnText="Ya"
      cancelBtnText="Tidak"
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <p style={{ marginBottom: extraNote ? "10px" : 0 }}>
        Setelah mengkonfirmasi tindakan tidak dapat dibatalkan.
      </p>
      {extraNote && (
        <p style={{ color: "#c0392b", fontWeight: 600, marginBottom: 0 }}>
          {extraNote}
        </p>
      )}
    </SweetAlert>
  );
}